module.exports = __webpack_public_path__ + "media/images/app/how-it-works/rent-by-the-day-mobile-aa4080ffc0dc25f3e912a742b784fb37.webp";